// extracted by mini-css-extract-plugin
module.exports = {"textPreWrap":"ReportByProjectsTable_textPreWrap__ol6az"};